
import { defineComponent, onMounted, computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import useOpenInfo from '@/hooks/openInfo'
import { setApptitle } from '@/utils/native-app'
import * as storage from '@/utils/storage'
import { useMutation, useQuery } from '@vue/apollo-composable'
import { mutateApi } from '@/graphql/mutation'
import { queryApi } from '@/graphql/query'
import { FormType, OpenAccountTypeMap, OpenStatus } from '@/enum'

export default defineComponent({
  setup () {
    const router = useRouter()
    const { openType, step, title, saveCommonOfVuex } = useOpenInfo()
    const commomParams = ref()
    const isShowSkip = ref(false)

    // 获取storage中的formType,用来区分普通开户和投资移民户
    const formType = computed(() => storage.get('formType'))
    const steps = computed(() => {
      return [
        { title: '绑定香港银行卡', remark: '与本人上传证件姓名相同' },
        { title: '转账', remark: formType.value === FormType.OPEN_ACCOUNT ? '单笔金额不低于10,000港币或1,500美元' : '单笔金额不低于10,000港币或1,500美元' },
        { title: '通知我们', remark: '上传转账凭证' }
      ]
    })

    // 保存下一步调用接口
    const saveNext = () => {
      commomParams.value = {
        openType: openType.value,
        openStatus: 1,
        btnText: '身份核实',
        remark: '距离开户成功只差最后一步',
        step
      }

      mutate({
        params: {
          formType: storage.get('formType'),
          meta: 'open_common',
          content: JSON.stringify(commomParams.value)
        }
      })
    }
    const handleNext = () => {
      saveNext()
    }

    const skip = () => {
      router.push({ name: 'account-opening-statement' })
    }

    const { onResult } = useQuery(queryApi.customerOpenStatus, {
      params: {
        openAccountType: OpenAccountTypeMap[formType.value as string] || 1
      }
    })

    onResult((res) => {
      const { customerOpenStatus } = res.data
      if (customerOpenStatus.ok) {
        if (customerOpenStatus.data.applicationStatus === OpenStatus.SUPPLEMENT) {
          isShowSkip.value = true
        }
      }
    })

    const { mutate, onDone } = useMutation(mutateApi.saveClientFormDraft)
    onDone((res) => {
      const { saveClientFormDraft } = res.data
      if (saveClientFormDraft.ok) {
        saveCommonOfVuex({ info: commomParams.value })
        router.push({ name: 'bind-card' })
      }
    })
    onMounted(() => {
      setApptitle(title)
    })

    return { steps, handleNext, skip, isShowSkip }
  }
})
